import { render, staticRenderFns } from "./PopupOverlay.vue?vue&type=template&id=1907042c&"
import script from "./PopupOverlay.vue?vue&type=script&lang=js&"
export * from "./PopupOverlay.vue?vue&type=script&lang=js&"
import style0 from "./PopupOverlay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports